<template>
    <div class="w-full max-w-500 mx-auto min-h-screen" data-cy="container_history_point_page_main">
        <div class="w-full h-full bg-a-blue-f2f5ff fixed top-0 left-0 right-0"></div>
        <HistoryMenu data-cy="component_history_menu" />
        <div class="mt-5 px-4 pb-24 relative" data-cy="container_history_point_content">
            <HistoryPoint data-cy="component_history_point" />
        </div>
        <MenuBar />
    </div>
</template>
<script>
//component
import HistoryMenu from '../component/HistoryMenu/HistoryMenu.vue';
import HistoryPoint from '../component/HistoryPoint/HistoryPoint.vue';
import MenuBar from '@/components/Layout/MenuBar/MenuBar.vue';
//mixin
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//service

export default {
    name: 'HistoryPointPage',
    mixins: [ModalMixin, AuthPageMixin],
    components: {
        HistoryMenu,
        HistoryPoint,
        MenuBar,
    },
    data: function() {
        return {

        };
    },
    created: function () {
        this.tracking.screenName('history');
        this.tracking.event('history_point', 'history_point', null, null);
    },
    mounted: async function() {
        // this.modal.loadingModal.show();
        // if (this.isHistoryRedeem) {
        //     await this.$refs['history-list'].getList();
        // }
        // this.modal.loadingModal.hide();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
    },
}
</script>
<style lang="scss" scoped>
</style>
